import styled from 'styled-components';

export const Main = styled.div`
  min-width: 768px;
  flex: 1 0 auto;
  width: 100vw;
  height: 100%;
  align-items: stretch;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px;
`;

export const Block = styled.div`
  min-width: 570px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ListsBlock = styled.div`
  height: 100%;
  width: 100%;
  padding-top: 15px;
  display: flex;
  justify-content: start;
`;

export const ListWrapper = styled.div`
  height: 100%;
  width: ${props => (props.maxDepth === 5 ? '20%' : '35%')};
  padding-left: ${props => (props.currentDepth === 0 ? '0' : '15px')};
`;
